import { render, staticRenderFns } from "./EbookChanters.vue?vue&type=template&id=49468f92&"
import script from "./EbookChanters.vue?vue&type=script&lang=js&"
export * from "./EbookChanters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports